import React from 'react';
import { withStyles, Typography, Grid, Tabs, Tab, Button, Divider, Chip } from '@material-ui/core';

// import projects from '../data/projects.json';
import styles from '../config/styles';
import riku from '../assets/TopView.png';
import spy from '../assets/spy.png';
import fitness from '../assets/fitness.png';
import rikuFront from '../assets/FrontRedDot.png'
import rikuSemiFront from '../assets/FrontViewRikuSemi.png'

// const TabContainer = withStyles(styles)((props) => {
//     const {classes} = props;
//     console.log(props.image)
//     return (
//         <Grid container justify="center" flexDirection="column">
//             <Grid item>
//                 <img src={props.image} className={classes.projectImage} alt={props.tagline}/>
//             </Grid>
//             <Grid item>
//                 <Typography variant="headline">
//                     {props.tagline}
//                 </Typography>
//                 <Typography variant="subheading">
//                     {props.shortDescription}
//                 </Typography>
//                 <Button variant="outlined" color="primary" size="large">Learn More</Button>
//             </Grid>
//         </Grid>
//     );
// });

class Projects extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0
        };
    }

    handleChange = (event, value) => {
        console.log(value)
        this.setState({ value: value });
    };

    render() {
        const { classes } = this.props;
        // const {value} = this.props;
        return (
            <section id="projects" className={[classes.section].join(" ")}>
                <div className={classes.innerBox}>
                    <div className={classes.innerHeaderSection}>
                        <Typography variant="h4">
                            Cool stuff we are working on
                        </Typography>
                    </div>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        className={classes.tabs}
                        scrollButtons={'on'}
                    >
                        <Tab label="Riku" />
                        <Tab label="Semi" />
                        {/* <Tab label="CodeName Hulk" />
                        <Tab label="CodeName F6" />
                        <Tab label="CodeName Air" /> */}
                    </Tabs>
                    <Divider style={{ marginBottom: "2em" }} />

                    {this.state.value === 0 &&
                        <Grid container justify="center" flexdirection="row" >
                            <Grid item className={classes.projectImageContainer} xs={12} sm={6} md={5} lg={5} xl={5} >
                                <img src={rikuFront} className={classes.projectImage} alt="Riku is the world's first Artificial Intelligence based Automatic Rice & Kurry Maker" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}  >
                                <div className={classes.projectDescription}>
                                    <Chip label="Automation" className={classes.chip} style={{ alignSelf: "flex-start" }} />
                                    <Typography variant="h5" className={classes.projectDescriptionName} >
                                        Now Cooking is just a click away!
                                    </Typography>
                                    <Typography variant="h5" style={{ flexBasis: "20%" }}>
                                        Riku is the world's first Artificial Intelligence based Automatic Rice & Kurry Maker
                                    </Typography>
                                    <div style={{ flexBasis: "25%" }}></div>
                                    <Button variant="outlined" color="secondary" size="large" href="http://getriku.com" target="_blank" rel="noopener noreferrer" style={{ alignSelf: "flex-start" }}>Learn More</Button>
                                </div >
                            </Grid>
                        </Grid>
                    }
                    {this.state.value === 1 &&
                        <Grid container justify="center" flexdirection="row">
                            <Grid item className={classes.projectImageContainer} xs={12} sm={6} md={5} lg={5} xl={5} >
                                <img src={rikuSemiFront} className={classes.projectImage} alt="Riku is the world's first Artificial Intelligence based Automatic Rice & Kurry Maker" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4} >
                                <div className={classes.projectDescription}>
                                    <Chip label="Automation" className={classes.chip} style={{ alignSelf: "flex-start" }} />
                                    <Typography variant="h5" className={classes.projectDescriptionName}>
                                        Your personal kitchen assistant.
                                    </Typography>
                                    <Typography variant="h5" style={{ flexBasis: "20%" }}>
                                        Semi is a smart induction cooktop which guides you every step of the way.
                                    </Typography>
                                    <div style={{ flexBasis: "25%" }}></div>
                                    <Button variant="outlined" color="secondary" size="large" href="http://cookwithsemi.com" target="_blank" rel="noopener noreferrer" style={{ alignSelf: "flex-start" }}>Learn More</Button>
                                </div >
                            </Grid>
                        </Grid>
                    }
                    {/* {this.state.value === 1 &&
                <Grid container justify="center" flexDirection="row">
                    <Grid container className={classes.projectImageContainer} xs={12} md={5} lg={5} xl={5}>
                        <img src={fitness} className={classes.spyProjectImage} alt="Always stay at the your peak fitness level."/>
                    </Grid>
                    <Grid item md={4} lg={4} xl={4} xs={12}>
                        <div  className={classes.projectDescription}>
                            <Chip label="Nutrition" className={classes.chip} style={{alignSelf: "flex-start"}}/>
                            <Typography variant="h5" style={{fontSize:35,marginTop: "20px", marginBottom:"10px",flexBasis: "26%",color:'rgba(0,0,0,0.5)'}}>
                                Always stay at the your peak fitness level.
                            </Typography>
                            <Typography  variant="h5" style={{flexBasis: "20%"}}>
                                Project is still under wraps.
                            </Typography>
                            <Typography variant="caption">
                                Want to be a part of the product development, please fill our <a href="https://docs.google.com/forms/d/e/1FAIpQLSc1wWZ0-FlYiu7DBqPCMqoFwIOsKpHyqGqGqIGFvumOatk34g/viewform?usp=sf_link" target="_blank" rel="noopener noreferrer">survey</a>.
                            </Typography>
                            <div style={{flexBasis: "25%"}}></div>
                            <Button  variant="outlined" color="secondary" size="large" onClick={this.props.openPopup} style={{alignSelf: "flex-start"}}>Keep Me Updated</Button>
                        </div >
                    </Grid>
                </Grid>
                }
                {this.state.value === 2 &&
                <Grid container justify="center" flexDirection="row">
                    <Grid container className={classes.projectImageContainer} xs={12} md={5} lg={5} xl={5}>
                        <img src={spy} className={classes.spyProjectImage} alt="Hardware prototyping at the click of a button."/> 
                    </Grid>
                    <Grid item md={4} lg={4} xl={4} xs={12}>
                        <div  className={classes.projectDescription}>
                            <Chip label="Hardware Prototyping" className={classes.chip} style={{alignSelf: "flex-start"}}/>
                            <Typography variant="h5" style={{fontSize:35,marginTop: "20px", marginBottom:"10px",flexBasis: "26%",color:'rgba(0,0,0,0.5)'}}>
                                Hardware prototyping at the click of a button.
                            </Typography>
                            <Typography  variant="h5" style={{flexBasis: "20%"}}>
                                Project is still under wraps.
                            </Typography>
                            <div style={{flexBasis: "25%"}}></div>
                            <Button  variant="outlined" color="secondary" size="large" onClick={this.props.openPopup} style={{alignSelf: "flex-start"}}>Keep Me Updated</Button>
                        </div >
                    </Grid>                    
                </Grid>    
                }                
                {this.state.value === 3 &&
                <Grid container justify="center" flexDirection="row">
                    <Grid container className={classes.projectImageContainer} xs={12} md={5} lg={5} xl={5}>
                        <img src={spy} className={classes.spyProjectImage} alt="A fresh breathe of air." />
                    </Grid>
                    <Grid item md={4} lg={4} xl={4} xs={12}>
                        <div  className={classes.projectDescription}>
                            <Chip label="Pollution" className={classes.chip} style={{alignSelf: "flex-start"}}/>
                            <Typography variant="h5" style={{fontSize:35,marginTop: "20px", marginBottom:"10px",flexBasis: "26%",color:'rgba(0,0,0,0.5)'}}>
                                A fresh breathe of air.
                            </Typography>
                            <Typography  variant="h5" style={{flexBasis: "20%"}}>
                                Project is still under wraps.
                            </Typography>
                            <div style={{flexBasis: "25%"}}></div>
                            <Button  variant="outlined" color="secondary" onClick={this.props.openPopup} style={{alignSelf: "flex-start"}}>Keep Me Updated</Button>
                        </div >
                    </Grid>
                </Grid>    
                } */}
                </div>

            </section>
        )
    }
}

// withStyles(styles)(TabContainer);
export default withStyles(styles)(Projects);